import { useState, useCallback } from "react";   
import { Row, Col, Button, Dropdown } from 'react-bootstrap'; 
import { getSettings } from "../../apis/settingApi";
import { SaveTableSettingsModal } from "./SaveTableSettingsModal";

export const SaveTableSettings = ({ gridParams, gridRef, tableType}) => {
    
    const [showSaveSettingsModal, setShowSaveSettingsModal] = useState(false);
    const [savedSettings, setSavedSettings] = useState(null);

    const applySort = useCallback((sortModel) => {
        if(sortModel && sortModel.length > 0)
        {
            
            gridRef.current.api.applyColumnState({defaultState: { sort: null },});
            gridRef.current.api.applyColumnState({state: sortModel, applyOrder: false});
        }
    }, []);
    
    const applySettings = () => {
        if(savedSettings.sort !== null)
        {
          if(savedSettings.sort.length > 0)
          {
            applySort(savedSettings.sort);
          }
        }
        if(savedSettings.filter !== null)
        {
          gridRef.current.api.setFilterModel(savedSettings.filter);
        }
    }
    

    const handleGetFilters = async () => {
        const response = await getSettings();
        const settings = response;
        
        if(settings && settings[tableType])
        {
            setSavedSettings({filter: settings[tableType].filters, sort: settings[tableType].sort});
        }
    }
    
    const handleOpenSaveJobModal = async () => {
        setShowSaveSettingsModal(true);
    }
    return (
        <>
            <SaveTableSettingsModal show={showSaveSettingsModal} setShow={setShowSaveSettingsModal} gridParams={gridParams} tableType={tableType}/>
            <Dropdown className="d-inline mx-2" onToggle={(isOpen) => { if (isOpen) handleGetFilters(); }}>
                <Button className={"button-table outside-table-button"} onClick={handleOpenSaveJobModal} label="Save Filters" aria-label="Save Filters">
                    Save Filters
                </Button>
                <Dropdown.Toggle className="button-table button-icon"  split id="dropdown-basic"/>
                <Dropdown.Menu className="save-filters-dropdown-menu">
                    <Dropdown.Item onClick={applySettings} className="apply-saved-settings">Apply Saved Settings</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}